
export default {
    //companyPortalUrl:'http://localhost:8080',
    companyPortalUrl:'https://portal.kotina.com',
    companyPortalOrigin:'portal.kotina.com',
};